"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VariantAssignmentServiceClient = void 0;
const HeaderNames_1 = require("../enums/HeaderNames");
const AxiosHttpClient_1 = require("../utils/AxiosHttpClient");
const TreatmentAssignmentVariantServiceResponse_1 = require("./TreatmentAssignmentVariantServiceResponse");
const package_json_1 = __importDefault(require("../../package.json"));
class VariantAssignmentServiceClient {
  constructor(clientSettings) {
    this.clientSettings = clientSettings;
    this.httpClient = new AxiosHttpClient_1.AxiosHttpClient();
  }
  async getVariantAssignments(assignmentRequest) {
    if (!assignmentRequest) assignmentRequest = {};
    return await this.fetch(assignmentRequest);
  }
  async fetch(assignmentRequest) {
    let headers = this.getHeaders(assignmentRequest);
    let serviceResponse = await this.httpClient.get(this.clientSettings.endpoint, {
      headers: headers
    });
    let response = new TreatmentAssignmentVariantServiceResponse_1.TreatmentAssignmentVariantServiceResponse(serviceResponse.data.AssignmentContext, serviceResponse.data.FlightingVersion, serviceResponse.data.Configs, serviceResponse.data.Flights);
    return response;
  }
  getHeaders(assignmentRequest) {
    var _a, _b, _c;
    let headers = {};
    //Parameters
    if (assignmentRequest === null || assignmentRequest === void 0 ? void 0 : assignmentRequest.parameters) {
      let params = [];
      assignmentRequest.parameters.forEach((values, key) => {
        values === null || values === void 0 ? void 0 : values.forEach(val => {
          if (val) {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
          }
        });
      });
      if (params.length > 0) headers[HeaderNames_1.HeaderNames.Parameters] = params;
    }
    //AssignmentScopes
    let assignmentScopes = [];
    (_a = assignmentRequest === null || assignmentRequest === void 0 ? void 0 : assignmentRequest.assignmentScopes) === null || _a === void 0 ? void 0 : _a.forEach(value => {
      if (value && value.trim() !== '') assignmentScopes.push(encodeURIComponent(value));
    });
    if (assignmentScopes.length > 0) headers[HeaderNames_1.HeaderNames.AssignmentScopes] = assignmentScopes;
    //RequiredVariants
    let requiredVariants = [];
    (_b = assignmentRequest === null || assignmentRequest === void 0 ? void 0 : assignmentRequest.requiredVariants) === null || _b === void 0 ? void 0 : _b.forEach(value => {
      if (value && value.trim() !== '') requiredVariants.push(encodeURIComponent(value));
    });
    if (requiredVariants.length > 0) headers[HeaderNames_1.HeaderNames.RequiredVariants] = requiredVariants;
    //BlockedVariants
    let blockedVariants = [];
    (_c = assignmentRequest === null || assignmentRequest === void 0 ? void 0 : assignmentRequest.blockedVariants) === null || _c === void 0 ? void 0 : _c.forEach(value => {
      if (value && value.trim() !== '') blockedVariants.push(encodeURIComponent(value));
    });
    if (blockedVariants.length > 0) headers[HeaderNames_1.HeaderNames.BlockedVariants] = blockedVariants;
    //SDK version
    headers[HeaderNames_1.HeaderNames.SdkVersion] = package_json_1.default.version;
    return headers;
  }
}
exports.VariantAssignmentServiceClient = VariantAssignmentServiceClient;